var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import 'react-table/react-table.css';
import { Button, Checkbox, Dimmer, Form, Loader, Message, Modal, Table } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { fetchSecondaryIfCatalog } from "../kit/secondary-if/SecondaryIfCatalog";
import { CatalogMode, deleteWithAuthn, getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { presetScaleEventsTable } from "./ChromogenPresetScalesPage";
var AutomatedIfPresetScalesPage = /** @class */ (function (_super) {
    __extends(AutomatedIfPresetScalesPage, _super);
    function AutomatedIfPresetScalesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadCatalog = function () {
            _this.setState({ loading: true, error: false }, function () {
                Promise.all([
                    fetchSecondaryIfCatalog(CatalogMode.Internal),
                    getWithAuthn('/admin/automated-if/preset-reagent-scales/events')
                        .then(function (resp) { return resp.json(); })
                ])
                    .then(function (_a) {
                    var catalog = _a[0], events = _a[1];
                    if (catalog) {
                        _this.setState({
                            platforms: catalog.automatedIfPlatforms,
                            scales: catalog.automatedIfPresetScales,
                            events: events,
                            loading: false
                        });
                    }
                    else {
                        _this.setState({ loading: false, error: true });
                    }
                })
                    .catch(function (err) { return console.error('Failed to load catalog:', err); });
            });
        };
        _this.openAddModal = function () {
            _this.setState({
                modalOpen: true,
                editingScale: undefined,
                formState: emptyForm(),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.openEditModal = function (scale) {
            _this.setState({
                modalOpen: true,
                editingScale: scale,
                formState: scaleToForm(scale),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.closeModal = function () {
            _this.setState({ modalOpen: false }, _this.loadCatalog);
        };
        _this.onPlatformChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { platform: d.value }) }); });
        };
        _this.onInputChange = function (e) {
            var _a = e.currentTarget, name = _a.name, value = _a.value;
            _this.setState(function (s) {
                var _a;
                return ({ formState: __assign(__assign({}, s.formState), (_a = {}, _a[name] = value, _a)) });
            });
        };
        _this.onActiveChange = function (_, d) {
            _this.setState(function (s) { var _a; return ({ formState: __assign(__assign({}, s.formState), { active: (_a = d.checked) !== null && _a !== void 0 ? _a : false }) }); });
        };
        _this.onToggleInactive = function () {
            _this.setState(function (s) { return ({ showInactive: !s.showInactive }); });
        };
        _this.submitForm = function () {
            var _a = _this.state, formState = _a.formState, editingScale = _a.editingScale;
            if (editingScale && !window.confirm('You are about to update the volumes for this preset scale! ' +
                'This action will retroactively update all the scales for kits that have been assigned this scale. ' +
                'Proceed with caution!')) {
                return;
            }
            var body = editingScale ? {
                oldUnitsLabel: editingScale.unitsLabel,
                unitsLabel: formState.unitsLabel,
                oldEncoderScaleUl: editingScale.encoderScaleUl,
                encoderScaleUl: parseInt(formState.encoderScaleUl, 10),
                oldAntibodyBlockMl: editingScale.antibodyBlockMl,
                antibodyBlockMl: parseInt(formState.antibodyBlockMl, 10),
                oldAntibodyDiluentMl: editingScale.antibodyDiluentMl,
                antibodyDiluentMl: parseInt(formState.antibodyDiluentMl, 10),
                oldDetectAMl: editingScale.detectAMl,
                detectAMl: parseInt(formState.detectAMl, 10),
                oldDetectBMl: editingScale.detectBMl,
                detectBMl: parseInt(formState.detectBMl, 10),
                oldDetectCMl: editingScale.detectCMl,
                detectCMl: parseInt(formState.detectCMl, 10),
                oldActive: editingScale.active,
                active: formState.active,
                oldEffectiveDate: editingScale.effectiveDate,
                effectiveDate: formState.effectiveDate || null
            } : {
                platform: formState.platform,
                units: parseInt(formState.units, 10),
                unitsLabel: formState.unitsLabel,
                encoderScaleUl: parseInt(formState.encoderScaleUl, 10),
                antibodyBlockMl: parseInt(formState.antibodyBlockMl, 10),
                antibodyDiluentMl: parseInt(formState.antibodyDiluentMl, 10),
                detectAMl: parseInt(formState.detectAMl, 10),
                detectBMl: parseInt(formState.detectBMl, 10),
                detectCMl: parseInt(formState.detectCMl, 10),
                active: formState.active,
                effectiveDate: formState.effectiveDate || null
            };
            var path = editingScale
                ? "/admin/automated-if/preset-reagent-scales/update/" + editingScale.id
                : '/admin/automated-if/preset-reagent-scales/add';
            _this.setState({ formLoading: true, formErrors: [], formSuccess: false }, function () {
                postJsonWithAuthn(path, JSON.stringify(body))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({ formLoading: false, formSuccess: true });
                    }
                    else if (resp.status === 400) {
                        return resp.json().then(function (err) {
                            _this.setState({ formLoading: false, formErrors: err.errors });
                        });
                    }
                    else {
                        _this.setState({
                            formLoading: false,
                            formErrors: [{ path: '/', msg: 'An unexpected error occurred' }]
                        });
                    }
                    return undefined;
                })
                    .catch(function (err) { return console.error('Failed to save scale:', err); });
            });
        };
        _this.addPresets = function () {
            if (!window.confirm('Add preset scales (20 and 90 slides) for Leica and Oncore?')) {
                return;
            }
            _this.setState({ bulkAdding: true }, function () {
                postJsonWithAuthn('/admin/automated-if/preset-reagent-scales/add-presets', JSON.stringify({}))
                    .then(function () { return _this.setState({ bulkAdding: false }, _this.loadCatalog); })
                    .catch(function (err) {
                    console.error('Failed to add presets:', err);
                    _this.setState({ bulkAdding: false });
                });
            });
        };
        _this.deleteScale = function (id) {
            if (!window.confirm("Delete scale #" + id + "?")) {
                return;
            }
            deleteWithAuthn("/admin/automated-if/preset-reagent-scales/" + id)
                .then(function (resp) {
                if (resp.ok) {
                    return _this.loadCatalog();
                }
                else if (resp.status === 400) {
                    return resp.json().then(function (errorResp) {
                        window.alert(errorResp.errors.map(function (e) { return e.msg; }).join('\n'));
                    });
                }
                else {
                    window.alert('An unexpected error occurred');
                }
            })
                .catch(function (err) { return console.error('Failed to delete scale:', err); });
        };
        _this.state = {
            loading: false,
            error: false,
            platforms: [],
            modalOpen: false,
            formState: emptyForm(),
            formLoading: false,
            formErrors: [],
            formSuccess: false,
            bulkAdding: false,
            showInactive: false
        };
        return _this;
    }
    AutomatedIfPresetScalesPage.prototype.componentDidMount = function () {
        this.loadCatalog();
    };
    AutomatedIfPresetScalesPage.prototype.render = function () {
        var _this = this;
        var _a = this.state, loading = _a.loading, error = _a.error, scales = _a.scales, events = _a.events, platforms = _a.platforms, modalOpen = _a.modalOpen, formState = _a.formState, formLoading = _a.formLoading, formErrors = _a.formErrors, formSuccess = _a.formSuccess, editingScale = _a.editingScale, bulkAdding = _a.bulkAdding, showInactive = _a.showInactive;
        var visibleScales = scales === null || scales === void 0 ? void 0 : scales.filter(function (s) { return showInactive || s.active; });
        var platformOptions = platforms.map(function (p) { return ({ key: p.id, text: p.alias, value: p.id }); });
        var modalTrigger = (React.createElement(Button, { icon: "plus", labelPosition: "left", label: "Add Scale", onClick: this.openAddModal }));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { maxWidth: '1500px', margin: '0 auto', padding: '1rem' } },
                React.createElement("h2", null, "Automated Gold IF Preset Scales"),
                React.createElement(Message, { info: true, style: { marginBottom: '1.5rem' } },
                    React.createElement(Message.Header, null, "How this page works"),
                    React.createElement("div", { style: { marginTop: '0.75rem' } },
                        React.createElement("p", null,
                            React.createElement("strong", null, "Add scale"),
                            " creates a new preset scale for a platform and unit count. The backend requires a valid platform, a non-blank units label, and reagent values greater than zero."),
                        React.createElement("p", null,
                            "Add also blocks three conflict cases. It rejects a second ",
                            React.createElement("strong", null, "active"),
                            " scale for the same platform and units, rejects an exact duplicate with the same reagent values, and rejects a duplicate effective date for the same platform and units when an effective date is provided."),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Update scale"),
                            " only updates editable fields on an existing scale. Platform and units are intentionally locked after creation, which is why they are disabled in edit mode."),
                        React.createElement("p", null, "Updating is the most sensitive action on this page. The UI warning reflects the backend behavior: changing reagent values retroactively affects kits that already reference that preset scale. The endpoint also records a diff-style event message describing what changed."),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Delete scale"),
                            " only succeeds when the scale is not assigned to any existing kits. If the scale is already in use, the backend returns a validation error instead of deleting it."),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Add Preset Scales"),
                            " calls a backend endpoint that seeds the default 20-slide and 90-slide presets for Leica and Oncore. It does not bypass validation, so any duplicate or conflicting preset is still skipped by the server."))),
                React.createElement(Dimmer.Dimmable, null,
                    React.createElement(Dimmer, { active: loading, inverted: true },
                        React.createElement(Loader, null)),
                    error && React.createElement(Message, { negative: true }, "Failed to load preset reagent scales."),
                    visibleScales && (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: { marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' } },
                            modalTrigger,
                            React.createElement(Button, { loading: bulkAdding, disabled: bulkAdding, onClick: this.addPresets }, "Add Preset Scales"),
                            React.createElement(Checkbox, { toggle: true, label: "Show inactive", checked: showInactive, onChange: this.onToggleInactive })),
                        React.createElement(Table, { striped: true, celled: true, compact: true },
                            React.createElement(Table.Header, null,
                                React.createElement(Table.Row, null,
                                    React.createElement(Table.HeaderCell, null, "ID"),
                                    React.createElement(Table.HeaderCell, null, "Platform"),
                                    React.createElement(Table.HeaderCell, null, "Units"),
                                    React.createElement(Table.HeaderCell, null, "Units Label"),
                                    React.createElement(Table.HeaderCell, null, "Encoder Scale (\u00B5L)"),
                                    React.createElement(Table.HeaderCell, null, "Ab Block (mL)"),
                                    React.createElement(Table.HeaderCell, null, "Ab Diluent (mL)"),
                                    React.createElement(Table.HeaderCell, null, "Detect A (mL)"),
                                    React.createElement(Table.HeaderCell, null, "Detect B (mL)"),
                                    React.createElement(Table.HeaderCell, null, "Detect C (mL)"),
                                    React.createElement(Table.HeaderCell, null, "Active"),
                                    React.createElement(Table.HeaderCell, null, "Effective Date"),
                                    React.createElement(Table.HeaderCell, null, "Actions"))),
                            React.createElement(Table.Body, null, visibleScales.sort(function (s) { return s.id; })
                                .map(function (scale) { return (React.createElement(ScaleRow, { key: scale.id, scale: scale, onEdit: _this.openEditModal, onDelete: _this.deleteScale })); })))))),
                events && presetScaleEventsTable(events),
                React.createElement(Modal, { open: modalOpen, onClose: this.closeModal, closeIcon: true },
                    React.createElement(Modal.Header, null, editingScale ? "Edit Scale #" + editingScale.id : 'Add Preset Reagent Scale'),
                    React.createElement(Modal.Content, null,
                        React.createElement(Dimmer.Dimmable, { as: Form, error: formErrors.length > 0 },
                            React.createElement(Dimmer, { active: formLoading, inverted: true },
                                React.createElement(Loader, null)),
                            formSuccess && React.createElement(Message, { positive: true }, "Saved successfully."),
                            React.createElement(ErrorDisplay, { errors: formErrors, errorPath: '/' }),
                            React.createElement(Form.Select, { label: "Platform", options: platformOptions, value: formState.platform, onChange: this.onPlatformChange, disabled: !!editingScale }),
                            React.createElement(Form.Input, { label: "Units", type: "number", name: "units", value: formState.units, onChange: this.onInputChange, disabled: !!editingScale }),
                            React.createElement(Form.Input, { label: "Units Label", type: "text", name: "unitsLabel", value: formState.unitsLabel, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Encoder Scale (\u00B5L)", type: "number", name: "encoderScaleUl", value: formState.encoderScaleUl, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Antibody Block (mL)", type: "number", name: "antibodyBlockMl", value: formState.antibodyBlockMl, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Antibody Diluent (mL)", type: "number", name: "antibodyDiluentMl", value: formState.antibodyDiluentMl, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Detect A (mL)", type: "number", name: "detectAMl", value: formState.detectAMl, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Detect B (mL)", type: "number", name: "detectBMl", value: formState.detectBMl, onChange: this.onInputChange }),
                            React.createElement(Form.Input, { label: "Detect C (mL)", type: "number", name: "detectCMl", value: formState.detectCMl, onChange: this.onInputChange }),
                            React.createElement(Form.Field, null,
                                React.createElement(Checkbox, { label: "Active", checked: formState.active, onChange: this.onActiveChange })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Effective Date (optional)"),
                                React.createElement("input", { type: "date", name: "effectiveDate", value: formState.effectiveDate, onChange: this.onInputChange }),
                                React.createElement("div", { style: { marginTop: '0.5rem', fontSize: '0.85em', color: '#666' } }, "Dates are relative to the Los Angeles timezone")),
                            React.createElement(Button, { primary: true, onClick: this.submitForm }, editingScale ? 'Update' : 'Add'),
                            React.createElement(Button, { onClick: this.closeModal }, "Cancel")))))));
    };
    return AutomatedIfPresetScalesPage;
}(React.Component));
export default AutomatedIfPresetScalesPage;
var ScaleRow = /** @class */ (function (_super) {
    __extends(ScaleRow, _super);
    function ScaleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEdit = function () { return _this.props.onEdit(_this.props.scale); };
        _this.handleDelete = function () { return _this.props.onDelete(_this.props.scale.id); };
        return _this;
    }
    ScaleRow.prototype.render = function () {
        var _a;
        var scale = this.props.scale;
        return (React.createElement(Table.Row, null,
            React.createElement(Table.Cell, null, scale.id),
            React.createElement(Table.Cell, null, scale.platform.label),
            React.createElement(Table.Cell, null, scale.units),
            React.createElement(Table.Cell, null, scale.unitsLabel),
            React.createElement(Table.Cell, null, scale.encoderScaleUl),
            React.createElement(Table.Cell, null, scale.antibodyBlockMl),
            React.createElement(Table.Cell, null, scale.antibodyDiluentMl),
            React.createElement(Table.Cell, null, scale.detectAMl),
            React.createElement(Table.Cell, null, scale.detectBMl),
            React.createElement(Table.Cell, null, scale.detectCMl),
            React.createElement(Table.Cell, null, scale.active ? 'Yes' : 'No'),
            React.createElement(Table.Cell, null, (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : '-'),
            React.createElement(Table.Cell, null,
                React.createElement(Button, { size: "tiny", icon: "edit", onClick: this.handleEdit }),
                React.createElement(Button, { size: "tiny", icon: "trash", negative: true, onClick: this.handleDelete }))));
    };
    return ScaleRow;
}(React.PureComponent));
var emptyForm = function () { return ({
    platform: '',
    units: '',
    unitsLabel: '',
    encoderScaleUl: '',
    antibodyBlockMl: '',
    antibodyDiluentMl: '',
    detectAMl: '',
    detectBMl: '',
    detectCMl: '',
    active: false,
    effectiveDate: ''
}); };
var scaleToForm = function (scale) {
    var _a;
    return ({
        platform: scale.platform.id,
        units: String(scale.units),
        unitsLabel: scale.unitsLabel,
        encoderScaleUl: String(scale.encoderScaleUl),
        antibodyBlockMl: String(scale.antibodyBlockMl),
        antibodyDiluentMl: String(scale.antibodyDiluentMl),
        detectAMl: String(scale.detectAMl),
        detectBMl: String(scale.detectBMl),
        detectCMl: String(scale.detectCMl),
        active: scale.active,
        effectiveDate: (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : ''
    });
};
//# sourceMappingURL=AutomatedIfPresetScalesPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AutomatedIfPresetScalesPage.js
// module id = 1480
// module chunks = 0